// api routes
import axios from 'axios';

import { url } from './endpointURL';

export const API = axios.create({ baseURL: url});


export const isUserRegistered = (user) => API.post('/check_user', user);

export const fetchUser = (email) => API.post('/fetch_user_samurai', email);

export const fetchSelectedCamera = (cameraData) => API.post('/fetch_camera', cameraData);

export const addUser = (userData) => API.post('/add_user', userData);

